import { Link } from "react-router-dom";
import { ExternalLink, Check, ArrowRight } from "lucide-react";
import { CAD } from "../../lib/format";
import { analytics } from "../../lib/analytics/ga4";

export function ProductCard({ product, featured = false }) {
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className={`group flex flex-col overflow-hidden rounded-2xl border border-border bg-card transition-transform duration-200 hover:-translate-y-1 hover:shadow-md ${featured ? "lg:col-span-2 lg:flex-row" : ""}`}
    >
      <div className={`relative overflow-hidden ${featured ? "lg:w-1/2" : ""}`}>
        <img src={product.image} alt={product.name} loading="lazy"
          className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${featured ? "h-56 lg:h-full" : "h-44"}`} />
        {product.badge && (
          <span className="absolute left-3 top-3 rounded-full bg-action px-3 py-1 text-xs font-semibold text-white">{product.badge}</span>
        )}
      </div>
      <div className={`flex flex-1 flex-col p-6 ${featured ? "lg:w-1/2 lg:p-8" : ""}`}>
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-action">{product.category}</div>
        <h3 className="font-heading text-xl font-bold text-foreground">{product.name}</h3>
        <p className="mt-1 text-sm text-muted-foreground">{product.tagline}</p>
        {featured && <p className="mt-3 text-sm text-foreground/80">{product.description}</p>}
        {featured && (
          <ul className="mt-4 grid gap-1.5 sm:grid-cols-2">
            {product.features.map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-foreground/80"><Check className="h-4 w-4 text-brand" /> {f}</li>
            ))}
          </ul>
        )}
        <div className="mt-auto flex items-center justify-between pt-5">
          <span className="font-heading text-2xl font-bold text-brand">{CAD(product.price)}<span className="text-sm font-medium text-muted-foreground"> CAD</span></span>
          <Link to={`/products/${product.id}`} data-testid={`product-view-${product.id}`}
            className="inline-flex items-center gap-1 text-sm font-semibold text-brand transition-colors hover:text-action">
            View details <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export function GumroadButton({ product, className = "", label = "Buy on Gumroad" }) {
  return (
    <a
      href={product.gumroadUrl} target="_blank" rel="noopener noreferrer"
      onClick={() => analytics.gumroadClick(product.id)}
      data-testid={`gumroad-btn-${product.id}`}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-action px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-action-hover ${className}`}
    >
      {label} — {CAD(product.price)} <ExternalLink className="h-4 w-4" />
    </a>
  );
}
